export const storeLinks = {
  apple: {
    client: "https://apps.apple.com/ar/app/viaj%C3%A1ya/id6470660494?l=en-GB",
    driver:
      "https://apps.apple.com/ar/app/viaj%C3%A1ya-driver/id6474763520?l=en-GB",
  },
  android: {
    client: "https://play.google.com/store/apps/details?id=com.viajaya",
    driver: "https://play.google.com/store/apps/details?id=com.viajayadriver",
  },
  wsp: "https://wa.me/5493515686840",
};
